import { IModelInfo, IModelMemberInfo } from "../../domain/ModelInfos/IModelInfo";
import { DeleteOutlined, KeyOutlined, QuestionOutlined, TagOutlined } from "@ant-design/icons";
import { when } from "../../helpers/tsxHelper";
import { ModelMemberTypeEditor } from "../../controls/ModelMemberTypeEditor";
import { ModelMemberNameEditor } from "../../controls/ModelMemberNameEditor";
import { Button, Divider, Drawer, Input, InputNumber, Switch } from "antd";
import { useState } from "react";

interface IProps {
    model: IModelInfo;
    modelMember: IModelMemberInfo;
    onChange: (changes: Partial<IModelMemberInfo>) => any;
    onDelete: (member: IModelMemberInfo) => any;
}

export function ModelMemberEditor(props: IProps) {
    const { model, modelMember, onChange, onDelete } = props;
    const [drawerOpen, setDrawerOpen] = useState(false);

    return (
        <div style={{ display: "grid", gridTemplateColumns: "1fr 2fr 2fr 0.5fr", columnGap: "5px", margin: "2px" }}>
            <Drawer title={<>{model.name}.{modelMember.name}</>} placement="right" onClose={() => setDrawerOpen(false)} open={drawerOpen} mask={false}>
                <ModelMemberEditorDetails modelMember={modelMember} onChange={onChange} />
            </Drawer>
            <div onClick={() => setDrawerOpen(true)}>
                <TagOutlined />
                {when(modelMember.isPrimaryKey, () => <KeyOutlined />)}
                {when(modelMember.nullable, () => <QuestionOutlined />)}
            </div>
            <ModelMemberNameEditor modelMember={modelMember} onChange={onChange} />
            <ModelMemberTypeEditor modelMember={modelMember} onChange={onChange} onClick={() => setDrawerOpen(true)} />
            <Button icon={<DeleteOutlined />} onClick={() => onDelete(modelMember)} size="small" />
        </div>
    );
}


export function ModelMemberEditorDetails(props: { modelMember: IModelMemberInfo; onChange: (changes: Partial<IModelMemberInfo>) => any }) {
    const { modelMember, onChange } = props;
    return (

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "5px", rowGap: "2px", margin: "2px", justifyContent: "center" }}>
            <div>Name</div>
            <div><Input value={modelMember.name} onChange={(e) => onChange({ name: e.target.value })} /></div>
            <div>Original name</div>
            <div><Input value={modelMember.originalName} onChange={(e) => onChange({ originalName: e.target.value })} /></div>

            <div><Divider /></div>
            <div><Divider /></div>

            <div>Type name</div>
            <div><Input value={modelMember.type.name} onChange={(e) => onChange({ type: { ...modelMember.type, name: e.target.value } })} /></div>
            <div>Original type name</div>
            <div><Input value={modelMember.type.originalName} onChange={(e) => onChange({ type: { ...modelMember.type, name: e.target.value } })} /></div>

            <div><Divider /></div>
            <div><Divider /></div>

            <div>Default value</div>
            <div><Input value={modelMember.defaultValue} onChange={(e) => onChange({ defaultValue: e.target.value })} /></div>

            <div>Primary Key</div>
            <div>
                <Switch checked={modelMember.isPrimaryKey} onChange={(checked) => onChange({ isPrimaryKey: checked })} />
            </div>
            <div>Nullable</div>
            <div>
                <Switch checked={modelMember.nullable} onChange={(checked) => onChange({ nullable: checked })} />
            </div>
            <div>Auto Increment</div>
            <div>
                <Switch checked={modelMember.autoIncrement} onChange={(checked) => onChange({ autoIncrement: checked })} />
            </div>
            <div>Length</div>
            <div><InputNumber value={modelMember.length} onChange={(value) => onChange({ length: value ?? undefined })} /></div>
            <div>Precision</div>
            <div><InputNumber value={modelMember.precision} onChange={(value) => onChange({ precision: value ?? undefined })} /></div>
            <div>Scale</div>
            <div><InputNumber value={modelMember.scale} onChange={(value) => onChange({ scale: value ?? undefined })} /></div>
        </div>
    );
}
